import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Observable } from 'rxjs';
import { MaterialMediaQueries } from '../enums/material-media-queries.enum';
import { AlertWrapperComponent } from './alert-wrapper/alert-wrapper.component';
import { AlertDialogData } from '../interfaces';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

export interface InjectedDialogComponent {
  dataObservable: Observable<any>;
}

@Injectable()
export class XpoDialogManagerService {
  private configDefaults: MatDialogConfig;

  constructor(private matDialog: MatDialog, private mediaQueryService: MediaObserver) {
    this.configDefaults = {
      width: '650px',
      panelClass: 'xpo-dialog-panel',
    };

    this.initializeWatchers();
  }

  public alert(alertOptions: AlertDialogData, configOverrides: MatDialogConfig = {}): MatDialogRef<any> {
    const defaultsWithData = { ...configOverrides, ...this.configDefaults };

    defaultsWithData.data = alertOptions;

    return this.matDialog.open(AlertWrapperComponent, defaultsWithData);
  }

  public open(dialogComponent: ComponentType<any> | TemplateRef<any>, configOverrides: MatDialogConfig = {}): MatDialogRef<any> {
    const dialogConfig = { ...configOverrides, ...this.configDefaults };
    return this.matDialog.open(dialogComponent, dialogConfig);
  }

  private initializeWatchers(): void {
    this.mediaQueryService.asObservable().subscribe(mediaChange => {
      this.configDefaults.width = this.mediaQueryService.isActive(MaterialMediaQueries.GT_MEDIUM) ? '650px' : '80%';
    });
  }
}
